import React, { Suspense, lazy } from 'react';
import { Routes, Route } from 'react-router-dom';
import { CircularProgress, Container } from '@material-ui/core';
import AppShell from './components/common/AppShell';
import HomePage from './pages/HomePage';
import ExplorePage from './pages/ExplorePage';
import PlaceDetailsPage from './pages/PlaceDetailsPage';
import SavedPage from './pages/SavedPage';
import ItineraryPage from './pages/ItineraryPage';
import ContactPage from './pages/ContactPage';
import NotFoundPage from './pages/NotFoundPage';

const AboutPage = lazy(() => import('./pages/AboutPage'));
const FaqPage = lazy(() => import('./pages/FaqPage'));

const App = () => (
  <AppShell>
    <Suspense
      fallback={(
        <Container style={{ padding: '3rem 0', textAlign: 'center' }}>
          <CircularProgress color="secondary" />
        </Container>
      )}
    >
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/explore" element={<ExplorePage />} />
        <Route path="/place/:placeId" element={<PlaceDetailsPage />} />
        <Route path="/saved" element={<SavedPage />} />
        <Route path="/itinerary" element={<ItineraryPage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/faq" element={<FaqPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </Suspense>
  </AppShell>
);

export default App;
